var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#010101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6ccad4",
    d: "M10.67 10.57v-.54c-.18-.02-.37-.04-.55-.04C7.85 9.99 6 11.84 6 14.11c0 1.39.7 2.63 1.76 3.37a4.07 4.07 0 0 1-1.09-2.8c0-2.24 1.78-4.05 4.01-4.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ccad4",
    d: "M10.77 16.56c1.01 0 1.85-.82 1.89-1.82V5.79h1.63c-.03-.2-.05-.39-.05-.58H12v8.97c-.04 1-.87 1.81-1.88 1.81-.31 0-.61-.08-.87-.22.34.47.9.8 1.52.8ZM17.35 8.85v-.53c-.62 0-1.21-.19-1.69-.5.43.5 1.02.89 1.69 1.03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3658",
    d: "M15.65 7.82c-.48-.55-.77-1.26-.77-2.04h-.61c.16.85.67 1.58 1.37 2.04ZM10.12 12.21c-1.04 0-1.89.86-1.89 1.9 0 .72.42 1.35 1.02 1.66-.22-.31-.36-.69-.36-1.1 0-1.04.84-1.88 1.88-1.88.19 0 .38.03.55.09V10.6c-.18-.02-.37-.04-.55-.04h-.1v1.73c-.18-.06-.35-.08-.54-.08Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee3658",
    d: "M17.35 8.82h-.01v1.73c-1.16 0-2.24-.38-3.12-1.01v4.57c0 2.27-1.83 4.11-4.1 4.11-.88 0-1.69-.27-2.36-.73.75.81 1.82 1.31 3.01 1.31 2.27 0 4.12-1.85 4.12-4.12v-4.55c.88.63 1.95 1 3.11 1V8.89c-.22 0-.44-.02-.65-.07"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.24 14.1V9.55c.88.63 1.95 1 3.11 1V8.81c-.67-.14-1.26-.5-1.69-1a3.1 3.1 0 0 1-1.36-2.04h-1.64v8.97c-.04 1-.87 1.81-1.88 1.81-.63 0-1.18-.31-1.52-.78-.6-.32-1.01-.94-1.01-1.66 0-1.04.84-1.88 1.88-1.88.19 0 .38.03.55.09v-1.75a4.12 4.12 0 0 0-4.02 4.12c0 1.08.42 2.07 1.11 2.8.67.47 1.48.75 2.36.75 2.27 0 4.12-1.85 4.12-4.12Z"
  })));
};
export default SvgTiktok;